import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import downloadJsonFile from '@/utils/general/fileDownload/downloadJsonFile';
import { mutationWithFeedback } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
function useExportAllNetworkRelatedData() {
  const $ = _c(2);
  const utils = trpc.useUtils();
  let t0;
  if ($[0] !== utils.network.exportNetwork) {
    t0 = async (networkId, historyLimit) => {
      const exportedNetwork = await mutationWithFeedback({
        mutation: utils.network.exportNetwork.fetch({
          networkId,
          historyLimit
        }, {
          staleTime: 0
        }),
        successText: "Network exported",
        errorText: "Failed to export network",
        loadingText: "Exporting..."
      });
      if (!exportedNetwork.network) {
        throw new Error("Exported network should contain information about the network itself: name, id (NetworkPopoverContainer.tsx)");
      }
      const networkName = exportedNetwork.network.name;
      downloadJsonFile({
        ...exportedNetwork
      }, `all_data_export__${networkName.replaceAll(" ", "_")}.json`);
    };
    $[0] = utils.network.exportNetwork;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default useExportAllNetworkRelatedData;